<template>
    <tr :class="{'eco-participation-line': line.is_eco_participation, 'ix-table-row-hidden-from-client': (canHide || showsHiddenFlag) && line.is_hidden_from_client}">
        <td class="text-center">
            <span class="ix-drag-icon handle-line"></span>
        </td>
        <td class="text-center">
            <span 
                v-b-tooltip.hover.right="hover_label">
                <input type="checkbox" 
                :disabled="line.amount != 0 || (editable ? false : true) || isProtectedArticle"
                value="1" 
                :id="'is_title_' + line.uniq" 
                :name="'lines[' + index + '][is_title]'"
                v-model="line.is_title"
                @change="compute">
            </span>
            <input type="hidden" v-if="line.amount != 0 || editable ? false : true" value="1"  :name="'lines[' + index + '][is_title]'"/>
        </td>
        <td>
            <input type="text" class="form-control form-control-sm" :name="'lines[' + index + '][reference]'" v-model="line.reference"  :disabled="line.is_eco_participation || (editable ? false : true)">
            <input type="hidden" :name="'lines[' + index + '][reference]'" v-model="line.reference"  v-if="line.is_eco_participation || (editable ? false : true)">
        </td>
        <td>
            <div class="input-group">
                <div class="input-group-prepend" v-if="line.article_id || line.is_eco_participation">
                    <span class="input-group-text">
                        <i class="far fa-cube" v-if="line.article_id && !line.is_eco_participation"></i>
                        <i class="far fa-recycle" v-if="line.is_eco_participation"></i>
                    </span>
                </div>
                <input placeholder="Commencer la saisie pour obtenir des suggestions .." class="form-control form-control-sm" :id="'suggestionAutocomplete' + line.uniq" type="text" :name="'lines[' + index + '][designation]'" v-model="line.designation" @input="emitEventLineEdited" :required="line.amount != 0 && line.is_title != 1"  :disabled="line.is_eco_participation || (editable ? false : true)">
            </div>
            <span class="ix-badge optional mt-1" v-if="line.is_optional">Option</span>
            <input type="hidden" :name="'lines[' + index + '][id]'" v-model="line.id">
            <input type="hidden" :name="'lines[' + index + '][designation]'" v-model="line.designation" v-if="line.is_eco_participation || (editable ? false : true)">
            <input type="hidden" :name="'lines[' + index + '][parent_id]'" v-model="line.parent_id">
            <input type="hidden" :name="'lines[' + index + '][article_id]'" v-model="line.article_id">
            <input type="hidden" :name="'lines[' + index + '][under_total]'" v-model="line.under_total"> 
            <input type="hidden" :name="'lines[' + index + '][description]'" v-model="line.description" v-if="line.is_eco_participation || (editable ? false : true)"> 
            <input type="hidden" :name="'lines[' + index + '][is_eco_participation]'" :value="line.is_eco_participation ? 1 : 0">
            <input type="hidden" :name="'lines[' + index + '][is_optional]'" :value="line.is_optional ? 1 : ''" v-if="model == 'quote'">
            <input type="hidden" :name="'lines[' + index + '][eco_category_id]'" v-model="line.eco_category_id" v-if="line.eco_category_id">
            <input type="hidden" :name="'lines[' + index + '][eco_parent_line_id]'" v-model="line.eco_parent_line_id" v-if="line.eco_parent_line_id">
            <input type="hidden" :name="'lines[' + index + '][is_hidden_from_client]'" :value="(canHide || showsHiddenFlag) && line.is_hidden_from_client ? 1 : 0" v-if="model == 'quote'">
            <input type="hidden" :name="'lines[' + index + '][line_type_style]'" :value="line.line_type_style" v-if="model == 'quote' && line.line_type_style">
            <div v-show="is_expanded === true">
                <textarea rows="2" class="form-control form-control-sm mt-2" :disabled="line.is_eco_participation || (editable ? false : true)" placeholder="description, informations complémentaires, .." :name="'lines[' + index + '][description]'" v-model="line.description"></textarea>
            </div>
        </td>
        <td :colspan="isAutoliquidation == 1 ? 4 : 5" v-if="line.is_title == 1"></td>
        <td v-if="line.is_title != 1">
            <input type="number" :disabled="line.is_eco_participation || (editable ? false : true)" class="form-control form-control-sm" :name="'lines[' + index + '][quantity]'" v-model="line.quantity" @blur="compute" required step="0.001">
            <input type="text"  :disabled="line.is_eco_participation || (editable ? false : true)" class="form-control form-control-sm mt-2" placeholder="unité" :name="'lines[' + index + '][unit]'" v-model="line.unit" v-show="is_expanded === true">


            <input type="hidden" v-if="line.is_eco_participation || (editable ? false : true)" v-model="line.quantity" :name="'lines[' + index + '][quantity]'"/>
            <input type="hidden" v-if="line.is_eco_participation || (editable ? false : true)" v-model="line.unit" :name="'lines[' + index + '][unit]'"/>
        </td>
        <td v-if="line.is_title != 1">
            <div class="input-group input-group-sm">
                <input type="number" class="form-control text-right"  :disabled="line.is_eco_participation || (editable ? false : true)" :name="'lines[' + index + '][amount]'" v-model="line.amount" @blur="compute" required step="0.001">
                <div class="input-group-append">
                    <span class="input-group-text" id="inputGroup-sizing-sm">€</span>
                </div>
            </div>


            <input type="hidden" v-if="line.is_eco_participation || (editable ? false : true)" v-model="line.amount" :name="'lines[' + index + '][amount]'"/>
        </td>
        <td v-if="line.is_title != 1">
            <div class="input-group input-group-sm">
                <input type="number" class="form-control text-center"  :disabled="line.is_eco_participation || (editable ? false : true)" :name="'lines[' + index + '][discount]'" v-model="line.discount" @blur="compute" required min="0" step="0.01">
                <div class="input-group-append">
                    <span class="input-group-text" id="inputGroup-sizing-sm">%</span>
                </div>
            </div>


            <input type="hidden" v-if="line.is_eco_participation || (editable ? false : true)" v-model="line.discount" :name="'lines[' + index + '][discount]'"/>
        </td>
        <td class="text-right" v-if="line.is_title != 1">{{ currency(line.total_ht) }}</td>
        <td v-if="line.is_title != 1 && isAutoliquidation != 1">
            <div class="input-group input-group-sm">
                <input type="number"  :disabled="editable ? false : true" class="form-control text-center" :name="'lines[' + index + '][vat]'"  v-model="line.vat" @blur="compute" required min="0" step="0.01">
                <div class="input-group-append">
                    <span class="input-group-text" id="inputGroup-sizing-sm">%</span>
                </div>
            </div>

            <input type="hidden" v-if="editable ? false : true" v-model="line.vat" :name="'lines[' + index + '][vat]'"/>
        </td>
        <td class="text-right">
            <span class="btn btn-sm transparent" v-if="canHide" @click="toggleHiddenFromClient"
                v-b-tooltip.hover :title="line.is_hidden_from_client ? 'Ligne masquée dans le devis client : cliquer pour l\'afficher' : 'Masquer cette ligne dans le devis client'">
                <i class="far" :class="line.is_hidden_from_client ? 'fa-eye-slash' : 'fa-eye'"></i>
            </span>
            <span class="btn btn-sm transparent" v-else-if="showsHiddenFlag"
                v-b-tooltip.hover title="Ligne masquée dans le devis client (masquage désactivé dans les paramètres)">
                <i class="far fa-eye-slash"></i>
            </span>

            <span class="btn btn-sm transparent" @click="expandRow">
                <i class="far fa-chevron-up" v-if="is_expanded === true"></i>
                <i class="far fa-chevron-down" v-if="is_expanded === false"></i>
            </span>

            <!-- Devis : une ligne optionnelle reste hors du total ; son éco-participation la suit -->
            <span class="btn btn-sm transparent" v-if="model == 'quote' && optionsEnabled && !line.is_eco_participation && editable" @click="$emit('line-toggle-optional', line)"
                  :title="line.is_optional ? 'En option : cliquer pour repasser en ligne normale' : 'Mettre en option'">
                <i class="fas" :class="line.is_optional ? 'fa-toggle-on ix-option-toggle-on' : 'fa-toggle-off'"></i>
            </span>

            <span class="btn btn-sm transparent" @click="emitEventLineDeleted"  v-show="!line.is_eco_participation && editable">
                <i class="far fa-trash"></i>
            </span>
        </td>
    </tr>
</template>

<script>
    import $ from 'jquery'
    import Swal from "sweetalert2";

    export default {
        name: 'line-form',
        props: ['line', 'index', 'discount', 'isAutoliquidation', 'suggestionsRoute', 'model', 'id', 'tva', 'editable', 'canHide', 'isProtectedArticle', 'showsHiddenFlag', 'optionsEnabled'],
        data() {
            return {
                errors: [],
                is_expanded: false,
                suggestions: [],
                globalTva: this.tva,
            };
        },
        watch: {
            discount: function () {
                this.compute();
            },
            isAutoliquidation: function (newVal, oldVal) {
                if (newVal == 1) {
                    this.line.vat = 0;
                    this.compute();
                }
            },
            tva: function(newVal, oldVal){
                if(newVal != oldVal){
                    this.globalTva = newVal;
                    this.line.vat = this.globalTva;
                    this.compute();
                }
            },
            'line.quantity': function(newVal, oldVal) {
                if (newVal !== oldVal && !this.line.is_eco_participation && this.line.article_id) {
                    const parsedNew = parseFloat(newVal);
                    if (!Number.isFinite(parsedNew)) {
                        return;
                    }

                    const parsedOld = parseFloat(oldVal);
                    const fallbackOld = Number.isFinite(this.line._last_valid_quantity) ? this.line._last_valid_quantity : parsedNew;

                    this.$emit('update-eco-lines-quantity', {
                        parentUniq: this.line.uniq,
                        newQuantity: parsedNew,
                        oldQuantity: Number.isFinite(parsedOld) ? parsedOld : fallbackOld
                    });

                    this.line._last_valid_quantity = parsedNew;
                }
            }
        },
        computed: {
            hover_label: function(){
                 let str = '';
                if(this.line.amount != 0)
                    str = 'Impossible de transformer cette ligne en titre car le montant est différent de 0,00€';
                else if(this.line.is_title)
                    str = '';
                else
                    str = 'Transformer cette ligne en titre';
                    
                return str;
            }
        },
        methods : {
            expandRow: function() {
                this.is_expanded = !this.is_expanded;
            },
            toggleHiddenFromClient: function() {
                if (!this.editable) {
                    return;
                }
                this.$set(this.line, 'is_hidden_from_client', !this.line.is_hidden_from_client);
            },
            compute: function() {
                // Prévention champs vide
                if (this.line.quantity == '' || this.line.quantity == null) { this.line.quantity = 0 }
                if (this.line.amount == '' || this.line.amount == null) { this.line.amount = 0 }
                if (this.line.discount == '' || this.line.discount == null) { this.line.discount = 0 }
                if ((this.line.vat === '' || this.line.vat === null ) && !this.line.is_title) { this.line.vat = this.globalTva ? this.globalTva : 0 }
           

                if (this.line.is_title) {
                    this.line.quantity = 1;
                    this.line.unit = null;
                    this.line.amount = 0;
                    this.line.discount = 0;
                    this.line.total_ht = 0;
                    this.line.total_discount = 0;
                    this.line.total_after_discount = 0;
                    this.line.total_vat = 0;
                    this.line.total_ttc = 0;
                    this.line.article_id = null;
                } else {
                    var price = parseFloat(this.line.quantity) * parseFloat(this.line.amount);
                    var discount = parseFloat(this.line.discount) !== 0 ? ((price / 100) * parseFloat(this.line.discount)) : 0;
                    this.line.total_ht = price - discount;

                    if (this.discount && !this.line.is_eco_participation) {
                        this.line.total_discount = (this.line.total_ht / 100) * this.discount
                        this.line.total_after_discount = this.line.total_ht - this.line.total_discount;
                    } else {
                        this.line.total_discount = 0;
                        this.line.total_after_discount = this.line.total_ht;
                    }
                    
                    this.line.total_after_discount = parseFloat(this.line.total_after_discount) || 0;
                    this.line.vat = parseFloat(this.line.vat) || 0; 
                    this.line.total_vat = parseFloat((this.line.total_after_discount * (this.line.vat / 100)).toFixed(2));
                    this.line.total_ttc = parseFloat((this.line.total_after_discount + this.line.total_vat).toFixed(2));

                }

                if (this.model == 'creditnote') {
                    this.line.total_ht = this.line.total_ht * -1;
                    this.line.total_after_discount = this.line.total_after_discount * -1;
                    this.line.total_vat = this.line.total_vat * -1;
                    this.line.total_ttc = this.line.total_ttc * -1;
                }

                setTimeout(() => {
                    this.updateLinesUnderTotal();
                }, 100);


            },
            updateLinesUnderTotal: function(){
                this.$emit('line-under-total-edited', {line : this.line});
            },
            updateLineTva: function(){

            },
            emitEventLineEdited: function () {
                this.$emit('line-editing-started', this.index)
            },
            emitEventLineDeleted: function () {
                Swal.fire({
                    title: 'Êtes-vous sûr ?',
                    text: "",
                    icon: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'Annuler',
                    confirmButtonColor: '#D15240',
                    confirmButtonText: 'Oui, supprimer',
                    reverseButtons: true,
                    heightAuto: false
                }).then((result) => {
                    if (result.value) {
                        this.$emit('line-deleted', this.index)
                    }
                })
            },
           fillLineProperties(item) {
                this.line.reference = item.reference;
                this.line.designation = item.designation;
                this.line.unit = item.unit;
                this.line.amount = item.amount;
                this.line.description = item.description;
                this.line.is_title = item.is_title;
                this.line.parent_id = item.parent_id;
                this.line.article_id = item.article_id ? item.article_id : null;
                
                // Cas 1: Mode override - Article avec tarif fixe du fournisseur
                if (item.eco_applicable && item.eco_participation && parseFloat(item.eco_participation) > 0) {
                    this.addEcoLineOverrideFromItem(item);
                    return;
                }
                
                // Cas 2: Mode calculé - Article avec catégories éco
                if (item.eco_applicable && item.eco_categories && item.eco_categories.length > 0) {
                    this.handleEcoParticipation(item);
                }
            },
            addEcoLineOverrideFromItem(item) {
                const parentQuantity = parseFloat(this.line.quantity) || 1;
                const supplierRate = parseFloat(item.eco_participation) || 0;
                
                const ecoLine = {
                    uniq: Date.now() + Math.random(),
                    parent_id: this.line.id || null,
                    parent_uniq: this.line.uniq,
                    eco_parent_line_id: this.line.id || null,
                    eco_parent_uniq: this.line.uniq,
                    is_eco_participation: true,
                    eco_category_id: null,
                    eco_rate_amount: supplierRate,
                    eco_unit_amount: supplierRate,
                    reference: '',
                    designation: 'Éco-participation',
                    quantity: parentQuantity,
                    unit: '',
                    amount: supplierRate,
                    discount: 0,
                    vat: this.globalTva || 20,
                    is_title: false,
                    article_id: null
                };

                this.$emit('add-eco-line', ecoLine);
            },
            handleEcoParticipation(item) {
                this.removeEcoLinesForArticle(this.line.uniq);

                const ecoCategoriesWithActiveRate = item.eco_categories
                    .map((ecoCategory) => ({
                        ecoCategory,
                        activeRate: this.getActiveRate(ecoCategory.eco_rates)
                    }))
                    .filter(({ activeRate }) => activeRate);

                const shouldDisplayCategory = ecoCategoriesWithActiveRate.length > 1;
                
                ecoCategoriesWithActiveRate.forEach(({ ecoCategory, activeRate }) => {
                    if (ecoCategory.calculation_mode === 'override') {
                        this.addEcoLineOverride(ecoCategory, activeRate, item, shouldDisplayCategory);
                    } else {
                        this.addEcoLineCalculated(ecoCategory, activeRate, item, shouldDisplayCategory);
                    }
                });
            },
            removeEcoLinesForArticle(articleUniq) {
                this.$emit('remove-eco-lines-for-article', articleUniq);
            },
            addEcoLineOverride(ecoCategory, rate, parentItem, shouldDisplayCategory) {
                const parentQuantity = parseFloat(this.line.quantity) || 1;
                const unitAmount = this.calculateEcoUnitAmount('override', rate, parentItem);

                const ecoLine = {
                    uniq: Date.now() + Math.random(),
                    parent_id: this.line.id || null,
                    parent_uniq: this.line.uniq,
                    eco_parent_line_id: this.line.id || null,
                    eco_parent_uniq: this.line.uniq,
                    is_eco_participation: true,
                    eco_category_id: ecoCategory.id,
                    eco_rate_amount: parseFloat(rate.amount) || 0,
                    eco_unit_amount: unitAmount,
                    reference: '',
                    designation: this.getEcoDesignation(ecoCategory.label, shouldDisplayCategory),
                    quantity: parentQuantity,
                    unit: '',
                    amount: unitAmount,
                    discount: 0,
                    vat: this.globalTva || 20,
                    is_title: false,
                    article_id: null
                };

                this.$emit('add-eco-line', ecoLine);
            },
            addEcoLineCalculated(ecoCategory, rate, parentItem, shouldDisplayCategory) {
                const parentQuantity = parseFloat(this.line.quantity) || 1;
                const unitAmount = this.calculateEcoUnitAmount(ecoCategory.calculation_mode, rate, parentItem);
                
                const ecoLine = {
                    uniq: Date.now() + Math.random(),
                    parent_id: this.line.id || null,
                    parent_uniq: this.line.uniq,
                    eco_parent_line_id: this.line.id || null,
                    eco_parent_uniq: this.line.uniq,
                    is_eco_participation: true,
                    eco_category_id: ecoCategory.id,
                    eco_rate_amount: parseFloat(rate.amount),
                    eco_unit_amount: unitAmount,
                    reference: '',
                    designation: this.getEcoDesignation(ecoCategory.label, shouldDisplayCategory),
                    quantity: parentQuantity,
                    unit: '',
                    amount: unitAmount,
                    discount: 0,
                    vat: this.globalTva || 20,
                    is_title: false,
                    article_id: null
                };

                this.$emit('add-eco-line', ecoLine);
            },
            getActiveRate(ecoRates) {
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                
                return ecoRates.find(rate => {
                    const startDate = rate.start_date ? new Date(rate.start_date) : null;
                    const endDate = rate.end_date ? new Date(rate.end_date) : null;
                    
                    if (startDate) startDate.setHours(0, 0, 0, 0);
                    if (endDate) endDate.setHours(0, 0, 0, 0);
                    
                    const afterStart = !startDate || today >= startDate;
                    const beforeEnd = !endDate || today <= endDate;
                    
                    return afterStart && beforeEnd;
                });
            },
            getEcoDesignation(categoryLabel, shouldDisplayCategory) {
                return shouldDisplayCategory ? `Éco-participation ${categoryLabel}` : 'Éco-participation';
            },
            calculateEcoUnitAmount(mode, rate, parentItem) {
                const rateAmount = parseFloat(rate.amount) || 0;
                const weight = parseFloat(parentItem.weight || 0);
                let result = 0;

                switch (mode) {
                    case 'unit':
                        result = rateAmount;
                        break;
                    case 'weight':
                        result = rateAmount * weight;
                        break;
                    case 'override':
                        result = rateAmount;
                        break;
                    default:
                        // Compatibilité legacy: l'ancien mode "fixed" est aligné sur "unit".
                        result = rateAmount;
                }

                return parseFloat(result.toFixed(4));
            }
        },
        mounted() {
            // Expand si description
            if (this.line.description) {
                this.is_expanded = true;
            }

            this.compute()

            var modelKey = this.model + "_id"

            // Creation autocomplete
            $("#suggestionAutocomplete" + this.line.uniq).autocomplete({
                minLength: 2,
                source: (request, response) => {
                    $.ajax({
                        url : this.suggestionsRoute,
                        type: 'get',
                        dataType : 'json',
                        headers: this.getHttpJsonRequestHeaders().headers,
                        data: {...{ q: request.term }, ...{deal_id: $('#deal_id').val()}, ...{[modelKey]: this.id}},
                        success: (data) => {
                            response($.map(data, (item) => {
                                return Object.assign(item, {
                                    label: item.designation,
                                    value: item.designation,
                                    formatted_amount: this.currency(item.amount)
                                });
                            }));
                        }
                    });
                },
                change: (e, item) => {
                    if(!item.item){ 
                        this.line.parent_id = null
                        this.line.article_id = null
                        // Supprimer les lignes éco-participation si l'article n'est plus sélectionné
                        this.removeEcoLinesForArticle(this.line.uniq)
                    }
                },
                create: function () {
                    $(this).data('ui-autocomplete')._renderItem = function (ul, item) {
                        var html = `<div class="d-flex align-items-center">
                                      <span class="badge badge-secondary">${item.category}</span>
                                      <span class="ml-2">${item.autocomplete_label}</span>`;

                        if (item.is_title) {
                            html += `</div>`
                        } else {
                            html += `<span class="ml-auto">${item.formatted_amount}</span>
                                    </div>`
                        }

                        return $('<li>')
                            .append(html)
                            .appendTo(ul);
                    };
                },
                select: (e, item) => {
                    this.fillLineProperties(item.item);
                    this.compute()
                }
            }).focus(() => {
                $("#suggestionAutocomplete" + this.line.uniq).autocomplete("search", '');
            });
        }
    }
</script>